import React from 'react';

const Gallery = () => {
  const images = [
    {
      url: 'https://images.pexels.com/photos/7195803/pexels-photo-7195803.jpeg',
      alt: 'Salon Interior',
      span: 'col-span-2 row-span-2',
    },
    {
      url: 'https://images.pexels.com/photos/3992879/pexels-photo-3992879.jpeg',
      alt: 'Hair Styling',
      span: 'col-span-1 row-span-1',
    },
    {
      url: 'https://images.pexels.com/photos/3993320/pexels-photo-3993320.jpeg',
      alt: 'Hair Coloring',
      span: 'col-span-1 row-span-1',
    },
    {
      url: 'https://images.unsplash.com/photo-1731514771613-991a02407132?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTZ8MHwxfHNlYXJjaHwyfHxiZWF1dHklMjB0cmVhdG1lbnQlMjBzcGElMjBmYWNpYWx8ZW58MHx8fHwxNzg0MzczMDMxfDA&ixlib=rb-4.1.0&q=85',
      alt: 'Beauty Treatment',
      span: 'col-span-1 row-span-1',
    },
    {
      url: 'https://images.pexels.com/photos/7195799/pexels-photo-7195799.jpeg',
      alt: 'Salon Chair',
      span: 'col-span-1 row-span-1',
    },
    {
      url: 'https://images.unsplash.com/photo-1616394584738-fc6e612e71b9?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTZ8MHwxfHNlYXJjaHwxfHxiZWF1dHklMjB0cmVhdG1lbnQlMjBzcGElMjBmYWNpYWx8ZW58MHx8fHwxNzg0MzczMDMxfDA&ixlib=rb-4.1.0&q=85',
      alt: 'Facial Treatment',
      span: 'col-span-2 row-span-1',
    },
  ];

  return (
    <div className="min-h-screen pt-24">
      {/* Hero */}
      <section className="py-20 bg-surface">
        <div className="max-w-4xl mx-auto px-6 text-center">
          <h1 className="text-4xl sm:text-5xl font-serif font-bold text-primary tracking-tight mb-6">
            Galerij
          </h1>
          <p className="text-lg text-muted-foreground leading-relaxed">
            Een kijkje in onze salon en de services die we aanbieden. Ervaar de luxe en
            professionaliteit van 4AN Hair & Beauty.
          </p>
        </div>
      </section>

      {/* Bento Grid Gallery */}
      <section className="py-20">
        <div className="max-w-6xl mx-auto px-6">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 auto-rows-[200px] gap-6">
            {images.map((image, index) => (
              <div
                key={index}
                className={`${image.span} image-scale-container rounded-sm overflow-hidden group cursor-pointer`}
              >
                <img
                  src={image.url}
                  alt={image.alt}
                  className="w-full h-full object-cover"
                />
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Testimonials Section */}
      <section className="py-32 bg-surface">
        <div className="max-w-4xl mx-auto px-6">
          <h2 className="text-3xl font-serif font-bold text-primary text-center mb-12">
            Wat Onze Klanten Zeggen
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            {[
              {
                name: 'Sophie V.',
                text: 'Geweldige salon! Het team is zeer professioneel en luistert echt naar wat je wilt. Mijn haar ziet er fantastisch uit!',
              },
              {
                name: 'Emma D.',
                text: 'Ik kom hier al jaren en ben elke keer weer tevreden. De kwaliteit is top en de sfeer is altijd gezellig.',
              },
            ].map((testimonial, index) => (
              <div key={index} className="bg-card border border-border rounded-sm p-8">
                <p className="text-muted-foreground italic leading-relaxed mb-4">
                  "{testimonial.text}"
                </p>
                <p className="font-semibold text-primary">— {testimonial.name}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default Gallery;
